<app-base-template (modal)="openModal(content)"(searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"
                   [showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Client Status Map</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected" (change)="onClientChange($event.target.selectedIndex)">
        <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
      </select>
    </div>
      <div class="form-group ticket-menu">
        <label class="status">Status:</label>
        <mat-checkbox class ="font-13" *ngFor="let stat of status" value="{{stat.id}}" [(ngModel)]="stat.checked">{{stat.name}}</mat-checkbox>
      </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter status Name"
                 [(ngModel)]="statusSelected">
      </div>
  </div>
  <div class="modal-footer pad-8">
     
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  
   

  </div>

  </ng-template>
<notifier-container></notifier-container>
